import { Mic } from 'react-feather';
import { BannerCallout } from './BannerCallout';
import { BANNER_AMBER } from './bannerTones';

/**
 * AI banner shown on the pre-session reflection page (MED-803 AC3 / AC4).
 *
 * Rendered only when the cohort's group-coaching modality has
 * `ai_features_enabled = true` (the caller is responsible for gating).
 *
 * Per AC #3 the banner has an icon and a placeholder message; per AC #6
 * the copy is a first-draft placeholder for client review and the
 * "What this means" link is intentionally NOT rendered (the mock has
 * one, but the AC text supersedes it).
 *
 * MED-1116 — uses the shared `BannerCallout` (amber tinted callout) so it reads
 * consistently with the peer-leader banner.
 */
export function AiBanner() {
  return (
    <BannerCallout
      tone={BANNER_AMBER}
      icon={Mic}
      title="AI listening will be on for this session"
      subtitle="The session leader can pause listening at any point during the session, and you'll see when that happens. Your reflection and personal notes aren't recorded — only what's said aloud."
    />
  );
}
